import Api from './Api';

class _LangApi extends Api {
    loadLangs(): Promise<any> {
        return this.getHttpClient().get(`lang/list`);
    }
}

export const LangApi = new _LangApi();
